export const fitLangMap = [
  {
    lang: 'python',
    packagesUrl: 'https://images.oscollege.net/resources/runner/top-packages-python.json',
    defaultEnvName: 'python3.12',
    versionList: [{ label: "python3.12", value: "oscollege-registry-vpc.cn-hangzhou.cr.aliyuncs.com/library/python-3.12:20251125"}],
    commentsFlag: '#'
  },
  {
    lang: 'python3',
    packagesUrl: 'https://images.oscollege.net/resources/runner/top-packages-python.json',
    defaultEnvName: 'python3.12',
    versionList: [{ label: "python3.12", value: "oscollege-registry-vpc.cn-hangzhou.cr.aliyuncs.com/library/python-3.12:20251125"}],
    commentsFlag: '#'
  },
  {
    lang: 'php',
    packagesUrl: 'https://images.oscollege.net/resources/runner/top-packages-php.json',
    defaultEnvName: 'php8.4',
    versionList: [{ label: "php8.4", value: "oscollege-registry-vpc.cn-hangzhou.cr.aliyuncs.com/oscollege/php-cli:20250325"}],
    commentsFlag: '<?php #'
  },
  {
    lang: 'javascript',
    packagesUrl: 'https://images.oscollege.net/resources/runner/top-packages-npm.json',
    defaultEnvName: 'node16',
    versionList: [{ label: "node16", value: "oscollege-registry-vpc.cn-hangzhou.cr.aliyuncs.com/oscollege/node:16.20.2"}],
    commentsFlag: '//'
  },
  {
    lang: 'typescript',
    packagesUrl: 'https://images.oscollege.net/resources/runner/top-packages-npm.json',
    defaultEnvName: 'node20',
    versionList: [{ label: "node20", value: "oscollege-registry-vpc.cn-hangzhou.cr.aliyuncs.com/oscollege/typescript:latest"}],
    commentsFlag: '//'
  },
  {
    lang: 'java',
    packagesUrl: 'https://images.oscollege.net/resources/runner/top-packages-maven.json',
    defaultEnvName: 'java21',
    versionList: [{ label: "java21", value: "oscollege-registry-vpc.cn-hangzhou.cr.aliyuncs.com/oscollege/openjdk:21-jdk-bullseye-fastjson"}],
    commentsFlag: '//'
  },
  {
    lang: 'c',
    packagesUrl: process.env.REACT_APP_API_URL + '/packages_c',
    defaultEnvName: 'c',
    versionList: [{ label: "c", value: "oscollege-registry-vpc.cn-hangzhou.cr.aliyuncs.com/oscollege/gcc:9.5.0_20250915"}],
    commentsFlag: '//'
  },
  {
    lang: 'cpp',
    packagesUrl: process.env.REACT_APP_API_URL + '/packages_c',
    defaultEnvName: 'cpp',
    versionList: [{ label: "cpp", value: "oscollege-registry-vpc.cn-hangzhou.cr.aliyuncs.com/oscollege/gcc:9.5.0_20250915"}],
    commentsFlag: '//'
  },
  {
    lang: 'systemverilog',
    defaultEnvName: 'verilog v5.036',
    versionList: [
      { label: "verilog v5.036", value: "verilog_v5.036", type: 0 },
      { label: "icarus verilog 12", value: "icarus_verilog_12", type: 1 }
    ],
  }
]
